export enum ElementModifierTypes {
    Disable = "Disable",
    Enable = "Enable",
    Show = "Show",
    Hide = "Hide" 
}